import { AdminFetchAppStatsEndAction } from "../actions";
import { AdminState } from "../state";

export function fetchAppStats(state: AdminState, action: AdminFetchAppStatsEndAction): AdminState {
    return { ...state, appStats: action.payload.stats };
}
